export const styles = theme => ({
  actionsContainer: {
    borderBottom: `1px solid ${theme.palette.border}`
  },
  likeButton: {
    padding: 0,
    fontSize: 12,
    color: 'inherit',
    borderRadius: 0
  },
  likeIcon: {
    fontSize: '18px',
    '&.liked': {
      color: theme.palette.text.brand
    },
    marginRight: '2px'
  },
  likeValue: {
    marginLeft: theme.spacing(0.5),
    fontSize: 13,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: 'inherit'
  },
  commentButton: {
    padding: 0,
    fontSize: 12,
    color: 'inherit',
    borderRadius: 0
  },
  commentIcon: {
    fontSize: 20,
    marginRight: '2px'
  },
  commentValue: {
    marginLeft: theme.spacing(0.5),
    fontSize: 13,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: 'inherit'
  },
  favoriteBtn: {
    padding: 0,
    fontSize: 12,
    lineHeight: '16px',
    color: 'inherit',
    textTransform: 'uppercase',
    borderRadius: 0
  },
  bookmarkIcon: {
    fontSize: '1.75em',
    '&.saved': {
      color: theme.palette.text.brand
    }
  }
});

export default styles;
